import React, { useState } from 'react';
import { View, Pressable, Text } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import * as colors from 'app/src/styles/colors';

const AnnouncementIcon = ({saleAsset, setSaleAssetAnnouncements,
  setAnnouncementAssetDetails
}) => {
  return (
    saleAsset.asset.announcements.length > 0 &&
      <Pressable
        onPress={() => {
          setSaleAssetAnnouncements(saleAsset.asset.announcements)
          setAnnouncementAssetDetails(
            `${saleAsset.lotNumber} | ${saleAsset.asset.name}`
          )
        }}
      >
        <FontAwesomeIcon
          icon={faTriangleExclamation}
          size={'1x'}
          color={colors.elRed}
          style={{marginLeft: '10px'}}
        />
      </Pressable>
  )
}

export default AnnouncementIcon;